import { GET_CIRCUIT_VPN_LOGS, GET_CIRCUIT_VPN_DETAILS_BY_EVENTS } from "./actionTypes";

const initialState = {
    circuitVpnLogs : [],
    totalRecords: 0,
    circuitVpnLogsErrorMessage : null,
    circuitVpnDetailsbyEvents : [],
    circuitVpnDetailsbyEventsErrorMessage: null,
    circuitVpnEventsbyRitm: [],
    circuitVpnEventsbyRitmErrorMessage: null
}

const circuitVpnReducer = (state = initialState, action = {type: ""}) => {
    switch (action.type) {
        case GET_CIRCUIT_VPN_LOGS.SUCCESS:
            let { eventList, totalRecords } = action.payload;
            return {
                ...state,
                circuitVpnLogs : eventList,
                totalRecords: totalRecords,
                circuitVpnLogsErrorMessage: null,
            }

        case GET_CIRCUIT_VPN_LOGS.ERROR:
            return {
                ...state,
                circuitVpnLogs: [],
                totalRecords: 0,
                circuitVpnLogsErrorMessage: action.payload,
            }

        case GET_CIRCUIT_VPN_DETAILS_BY_EVENTS.SUCCESS:
            return {
                ...state,
                circuitVpnDetailsbyEvents: action.payload,
                circuitVpnDetailsbyEventsErrorMessage: null
            }

        case GET_CIRCUIT_VPN_DETAILS_BY_EVENTS.ERROR:
            return {
                ...state,
                circuitVpnDetailsbyEvents: [],
                circuitVpnDetailsbyEventsErrorMessage: action.payload
            }

        default:
            return {
                ...state
            }

    }

}

export default circuitVpnReducer;